import { registerGetTrackingDataHandler } from './messageListener';

export const registerListeners = () => {
  registerGetTrackingDataHandler();
};
